/* ==========================================================================
   More Arrivals: carrusel de páginas con AUTOPLAY.
   - Avanza solo cada 4.5s (en bucle) mientras la sección está a la vista.
   - Se pausa con el cursor encima, al tocar/arrastrar y con el foco dentro.
   - prefers-reduced-motion => sin autoplay (los dots siguen funcionando).
   ========================================================================== */

(function () {
  'use strict';

  var INTERVAL = 4500;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.moreBound === 'true') return;
    var track = root.querySelector('[data-more-track]');
    var dots = root.querySelector('[data-more-dots]');
    if (!track) return;
    var pages = track.querySelectorAll('.gyaa-more__page');
    if (pages.length < 2) return;
    root.dataset.moreBound = 'true';

    var step = pages[1].offsetLeft - pages[0].offsetLeft;
    var index = 0;
    var paused = false;
    var visible = false;
    var timer = null;

    function buildDots() {
      if (!dots) return;
      dots.textContent = '';
      for (var p = 0; p < pages.length; p++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gyaa-more__pagedot' + (p === 0 ? ' is-active' : '');
        dot.dataset.page = String(p);
        dots.appendChild(dot);
      }
    }

    function sync() {
      step = pages[1].offsetLeft - pages[0].offsetLeft || track.clientWidth;
      index = Math.round(track.scrollLeft / step);
      if (dots) {
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].classList.toggle('is-active', i === index);
        }
      }
    }

    function goTo(i) {
      var target = (i + pages.length) % pages.length;
      track.scrollTo({ left: step * target, behavior: 'smooth' });
    }

    function tick() {
      if (!paused && visible && !document.hidden) goTo(index + 1);
    }

    function start() {
      if (reduced || timer) return;
      timer = setInterval(tick, INTERVAL);
    }

    buildDots();

    track.addEventListener('scroll', function () {
      clearTimeout(track._syncT);
      track._syncT = setTimeout(sync, 80);
    });

    if (dots) {
      dots.addEventListener('click', function (event) {
        var dot = event.target.closest('.gyaa-more__pagedot');
        if (dot) goTo(Number(dot.dataset.page));
      });
    }

    /* Pausas: cursor encima, interacción táctil y foco dentro */
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('pointerdown', function () { paused = true; });
    track.addEventListener('pointerup', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    /* Solo avanza cuando la sección se ve */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(root);
    } else {
      visible = true;
    }

    start();
  }

  function boot() {
    var roots = document.querySelectorAll('.gyaa-more');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
